@import "../../variables.scss";
$color-rejected-status: #d4403a;
$color-pending-status: #4488ff;
$color-approved-status: #0ead0e;

.onboarding {
  &__wrapper {
    padding: 1rem;
    border-bottom: #d0d0d0 1px solid;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
    flex-direction: row;

    @media (max-width: $size-sm) {
      align-items: flex-start;
      flex-direction: column;
    }
  }

  &__wrapper:nth-child(odd) {
    @media (max-width: $size-md) {
      background-color: rgba(0, 30, 83, 0.05);
    }
  }

  &__wrapper:last-child {
    border-bottom: 0;
  }

  &__btn {
    min-width: 126px;
    @media (max-width: $size-sm) {
      width: 100%;
    }
  }

  &__status {
    width: 93px;
    border: 2px solid;
    border-radius: 21px;
    text-transform: uppercase;
    text-align: center;
    padding: 7px 2px;
    font-family: Lato;
    font-size: 18px;
    letter-spacing: 0.34px;
    line-height: 22px;
    display: inline-block;
    font-weight: 700;
    height: 40px;
    flex-shrink: 0;
    @media (max-width: $size-md) {
      order: 1;
      max-height: 40px;
    }
  }

  &__todo {
    background-color: rgba(217, 83, 79, 0.05);
    border-color: $color-rejected-status;
    color: $color-rejected-status;
  }

  &__done {
    background-color: rgba(14, 173, 14, 0.05);
    border-color: $color-approved-status;
    color: $color-approved-status;
  }

  &__pending {
    border-color: #2196f3;
    color: #2196f3;
  }
}
